import {
  boolean,
  type InferOutput,
  number,
  object,
  optional,
  string
} from 'valibot'

import {
  createSorterSchema,
  SHIPMENT_CATEGORIES_SORT_KEYS
} from '@/features/shared/models'

export const ShipmentCategoriesSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  ...createSorterSchema(SHIPMENT_CATEGORIES_SORT_KEYS),
  dcId: optional(number()),
  name: optional(string()), // 項目名
  enable: optional(boolean()) // 有効/無効フラグ
})

export type ShipmentCategoriesSearch = InferOutput<
  typeof ShipmentCategoriesSearchSchema
>
